import React, { useEffect, useState } from 'react';
import { POSTURE_THEME } from './lib/theme';

const LevelIndicator: React.FC = () => {
  const [tilt, setTilt] = useState<{ x: number; y: number }>({ x: 0, y: 0 });
  const [isSupported, setIsSupported] = useState(false);

  useEffect(() => {
    const handleOrientation = (event: DeviceOrientationEvent) => {
      // beta is front-to-back tilt in degrees, range [-180,180]
      // gamma is left-to-right tilt in degrees, range [-90,90]
      if (event.gamma !== null && event.beta !== null) {
        setTilt({ x: event.gamma, y: event.beta });
        setIsSupported(true);
      }
    };

    if (window.DeviceOrientationEvent) {
      window.addEventListener('deviceorientation', handleOrientation);
    }

    return () => {
      window.removeEventListener('deviceorientation', handleOrientation);
    };
  }, []);

  if (!isSupported) return null;

  // We mostly care about holding the phone upright (beta ~90) and level (gamma ~0)
  // But for simple "level", gamma is key (left/right tilt)
  
  const isLevel = Math.abs(tilt.x) < 3; // 3 degrees tolerance
  
  return (
    <div className={`absolute top-4 left-1/2 transform -translate-x-1/2 px-3 py-1 rounded-full backdrop-blur-md transition-colors duration-300 border ${isLevel ? 'bg-success text-success-foreground/20 border-success text-success-text' : 'bg-error text-error-foreground/20 border-error text-error-text'}`}>
      <div className="flex items-center gap-2 text-xs font-bold">
        <div className={`w-2 h-2 rounded-full ${isLevel ? 'bg-success text-success-foreground' : 'bg-error text-error-foreground'}`} />
        {isLevel ? 'LEVEL' : `TILT: ${Math.round(tilt.x)}°`}
      </div>
    </div>
  );
};

export default LevelIndicator;

